module.exports = __webpack_public_path__ + "img/exam_show_bg01.794ecd96.png";